import React, { Fragment } from "react"
import PropTypes from "prop-types"
import _map from "lodash/map"
import _isNil from "lodash/isNil"
import _isEmpty from "lodash/isEmpty"

import Typograph from "components/Typograph/index"
import ContentView from "scenes/Customer/components/ContentView"

import { verifyWorklistName } from "../utils/verifyWorklistName"

import styles from "./styles.css"

const ContentWorkList = ({ t, worklist }) => {
  const showWorlist = !_isNil(worklist) && !_isEmpty(worklist)

  if (!showWorlist) return null

  return (
    <ContentView>
      <Typograph
        htmlTag="h4"
        size="medium"
        weight="regular"
        color="outer_space"
        classNames={styles.worlistTitle}
      >
        {`${t("MSG_0243")}:`}
      </Typograph>
      {_map(worklist, (item, index) => (
        <Fragment key={item.worklistName}>
          <Typograph
            htmlTag="p"
            size="medium"
            weight="bold"
            color="outer_space"
          >
            {`Etapa ${index + 1} - Protocolo: ${item.protocolNumber}`}
          </Typograph>
          <Typograph
            htmlTag="p"
            size="medium"
            weight="bold"
            color="outer_space"
          >
            {verifyWorklistName(item.worklistName)}
          </Typograph>
        </Fragment>
      ))}
    </ContentView>
  )
}

ContentWorkList.propTypes = {
  t: PropTypes.func,
  worklist: PropTypes.array
}

export default ContentWorkList



// WEBPACK FOOTER //
// ./src/scenes/IncidentManager/components/RequestTrackingModal/ContentWorkList.js